import { useRequestStore } from "entities/Request";
import { Fragment } from "react";
import { Badge, Popover } from "react-bootstrap";
import { RequestAccessController } from "entities/Request/utils/RequestAccessController";
import { useTranslation } from "react-i18next";
import { Button } from "shared/ui";
import { REQUEST_STATUSES, ROLES } from "shared/config";

const access = new RequestAccessController();

function ExpenseRequestControls({
  userRole,
  isReadyToBeAccepted,
  isReadyToBeReturned,
  loadingState,
  handleCostLineCreation,
  handleCostLineCreationWithOCR,
  handleWithdrawalModalShow,
  triggerRequestSave,
  triggerRequestSubmit,
  triggerRequestReturn,
  handleRejectionModalShow,
  triggerRequestAccept,
  currentCostLinesCount,
  requestStatus,
}) {
  const { t } = useTranslation("Request");
  const request = useRequestStore((state) => state.request);
  const withAdvancePayments = !!request?.advance_payments?.data?.length;

  if (userRole === ROLES.COST_GROUP)
    return (
      <>
        <Button
          variant="outline-primary"
          onClick={triggerRequestSave}
          isLoading={loadingState.isSaving}
          disabled={loadingState.isSaving || loadingState.isSubmitting}
          className="w-100"
        >
          {t("buttons.save")}
        </Button>
        <Button
          onClick={triggerRequestSubmit}
          isLoading={loadingState.isSubmitting}
          disabled={
            loadingState.isSubmitting ||
            loadingState.isSaving ||
            !isReadyToBeAccepted
          }
        >
          {t("buttons.submit")}
        </Button>
      </>
    );

  return (
    <>
      {userRole === ROLES.USER ? (
        <>
          <Button
            disabled={loadingState.isWithdrawing}
            isLoading={loadingState.isWithdrawing}
            onClick={handleWithdrawalModalShow}
            className="w-100"
          >
            {t("buttons.withdraw")}
          </Button>
          {withAdvancePayments ? (
            requestStatus !== REQUEST_STATUSES.AWAITING_USER_ACTION && (
              <Button
                variant="outline-primary"
                onClick={triggerRequestSave}
                isLoading={loadingState.isSaving}
                disabled={loadingState.isSaving || loadingState.isSubmitting}
                className="w-100"
              >
                {t("buttons.save")}
              </Button>
            )
          ) : (
            <Button
              variant="outline-primary"
              onClick={triggerRequestSave}
              isLoading={loadingState.isSaving}
              disabled={loadingState.isSaving || loadingState.isSubmitting}
              className="w-100"
            >
              {t("buttons.save")}
            </Button>
          )}

          {access.to("CostLine", "add").provided() && withAdvancePayments ? (
            requestStatus !== REQUEST_STATUSES.AWAITING_USER_ACTION && (
              <Button
                variant="outline-primary"
                onClick={handleCostLineCreation}
                className="w-100"
              >
                {t("buttons.new_cost_line")}
              </Button>
            )
          ) : (
            <Button
              variant="outline-primary"
              className="w-100"
              onClick={handleCostLineCreation}
            >
              {t("buttons.new_cost_line")}
            </Button>
          )}

          {request.ocr_active && (
            <Button
              variant="outline-primary stretch-item"
              className="w-100"
              onClick={handleCostLineCreationWithOCR}
            >
              {t("buttons.new_line_with_ocr")}
              <Badge className="ms-2">New</Badge>
            </Button>
          )}

          <Button
            onClick={triggerRequestSubmit}
            isLoading={loadingState.isSubmitting}
            disabled={loadingState.isSubmitting || loadingState.isSaving}
            className="w-100"
          >
            {t("buttons.submit")}
          </Button>
        </>
      ) : (
        <>
          {userRole === ROLES.ACCOUNTS_PAYABLE && (
            <Button
              variant="outline-primary"
              onClick={triggerRequestSave}
              isLoading={loadingState.isSaving}
              disabled={loadingState.isSaving || loadingState.isSubmitting}
              className="w-100"
            >
              {t("buttons.save")}
            </Button>
          )}
          <Button onClick={handleRejectionModalShow} className="w-100">
            {t("buttons.reject_request")}
          </Button>
          {currentCostLinesCount > 0 && (
            <Button.WithPopover
              popover={
                !isReadyToBeReturned ? (
                  <Popover body id="test-id">
                    {t("button_tooltips.return_for_correction")}
                  </Popover>
                ) : (
                  <Fragment />
                )
              }
              variant="warning"
              className="w-100"
              disabled={!isReadyToBeReturned || loadingState.isReturning}
              isLoading={loadingState.isReturning}
              onClick={triggerRequestReturn}
            >
              {t("buttons.return_for_correction")}
            </Button.WithPopover>
          )}
          <Button.WithPopover
            popover={
              !isReadyToBeAccepted ? (
                <Popover body>
                  {userRole === ROLES.ACCOUNTS_PAYABLE
                    ? t("button_tooltips.accept_request_accounts_payble")
                    : t("button_tooltips.accept_request")}
                </Popover>
              ) : (
                <Fragment />
              )
            }
            className="w-100"
            onClick={triggerRequestAccept}
            isLoading={loadingState.isAccepting}
            disabled={
              loadingState.isAccepting ||
              loadingState.isSaving ||
              !isReadyToBeAccepted
            }
          >
            {userRole === ROLES.ACCOUNTS_PAYABLE || currentCostLinesCount === 0
              ? t("buttons.accept_request")
              : t("buttons.accept_request_all_lines")}
          </Button.WithPopover>
        </>
      )}
    </>
  );
}

export default ExpenseRequestControls;
